$.module('MM.user.popup', function () {
  var _template = {
    wrapper:
      '\
            <i class="icon-close iconfont" onclick="MM.ui.popup.hide();" data-sawebclick="id=tc002b007&desc=关闭"></i>\
            <div class="inline user-popup-video">\
                <div class="video-content"></div></div><div class="inline user-popup-content"></div>\
            <div class="autocomplete-off hide">\
                <input class="hide" name="username"  type="text" disabled autocomplete="off"/>\
                <input class="hide" name="password"  type="password" disabled autocomplete="off"/>\
                <input class="hide" name="fakeMobile" type="text" disabled autocomplete="off"/>\
                <input class="hide" name="sms_code" type="text" disabled autocomplete="off"/>\
                <input class="hide" name="code" type="text" disabled autocomplete="off"/>\
                <input class="hide" name="pwd" type="password" disabled autocomplete="off"/>\
            </div>',

    thirdLogin:
      '<div class="third-login-content popup-content-inner">\
            <div class="popup-content-title">\
                <h6>欢迎回来，朋友</h6>\
                <p>登录您的账号，让我们来一次重逢吧！</p>\
            </div>\
            <ul>\
                <li class="qq-login-icon"><a href="javascript:MM.user.redirectToLogin(\'qq\');" data-sawebclick="id=tc002b001&desc=QQ登录"><i class="iconfont icon-qq-"></i><span>QQ登录</span></a></li>\
                <li class="wechat-login-icon"><a href="javascript:MM.user.redirectToLogin(\'weixin_pc\');" data-sawebclick="id=tc002b002&desc=微信登录"><i class="iconfont icon-weixin-"></i><span>微信登录</span></a></li>\
                <li class="weibo-login-icon"><a href="javascript:MM.user.redirectToLogin(\'sina\');" data-sawebclick="id=tc002b003&desc=微博登录"><i class="iconfont icon-weibo-"></i><span>微博登录</span></a></li>\
            </ul>\
            <div class="user-popup-bottom">\
                <div class="bottom-extra fl">\
                    <span data-tab="loginForm" data-sawebclick="id=tc002b004&desc=账号登录">账号登录&nbsp;&nbsp;|&nbsp;&nbsp;</span><span data-tab="registerForm" data-sawebclick="id=tc002b005&desc=立即注册">立即注册</span>\
                </div>\
                <div class="bottom-conner fr" data-tab="download" data-sawebclick="id=tc002b006&desc=下载APP">\
                    <a href="javascript:;">下载APP体验更多互动</a>\
                    <i class="corner-icon login-qrcode-icon"></i>\
                </div>\
            </div>\
        </div>',

    loginForm:
      '<div class="login-form-content popup-content-inner">\
            <div class="popup-content-title">\
                <h6>欢迎回来，朋友</h6>\
                <p>登录您的账号，让我们来一次重逢吧！</p>\
                <div class="ui-form-tip error-tip"></div>\
            </div>\
            <form id="app-login-form" autocomplete="off">\
                <div class="ui-form-item">\
                    <input class="ui-form-input" name="username" type="text" placeholder="请输入手机号/用户名/么么号" autocomplete="off"/>\
                </div>\
                <div class="ui-form-item">\
                    <input class="ui-form-input" name="password"  onfocus="this.type=\'password\'" placeholder="请输入密码" autocomplete="off"/>\
                </div>\
                <div class="fix extra-form-content">\
                    <p class="fl"><i class="iconfont icon-gouxuan inline"></i><span class="inline" data-sawebclick="id=tc008b001&desc=记住我">记住我</span></p>\
                    <span class="fr" data-tab="registerForm" data-sawebclick="id=tc008b003&desc=立即注册">&nbsp;&nbsp;|&nbsp;&nbsp;立即注册</span>\
                    <a class="fr btn-forgot-password" href="javascript:;"  data-sawebclick="id=tc008b002&desc=忘记密码">忘记密码？</a>\
                </div>\
                <div class="ui-form-item-submit"><p class="ui-form-btn btn-login" data-sawebclick="id=tc008b004&desc=登录">登&nbsp;&nbsp;录</p></div>\
            </form>\
            <div class="user-popup-bottom">\
                <div class="bottom-extra fl">\
                    <ul>\
                        <li>一键登录: </li>\
                        <li class="wechat-login-icon"> <a href="javascript:MM.user.redirectToLogin(\'qq\');" data-sawebclick="id=tc008b005&desc=QQ"><i class="iconfont icon-qq-" title="QQ登录"></i></a></li>\
                        <li class="qq-login-icon"> <a href="javascript:MM.user.redirectToLogin(\'weixin_pc\');" data-sawebclick="id=tc008b006&desc=微信"><i class="iconfont icon-weixin-" title="微信登录"></i></a></li>\
                        <li class="weibo-login-icon"> <a href="javascript:MM.user.redirectToLogin(\'sina\');" data-sawebclick="id=tc008b007&desc=微博"><i class="iconfont icon-weibo-" title="微博登录"></i></a></li>\
                    </ul>\
                </div>\
                <div class="bottom-conner fr" data-tab="download" data-sawebclick="id=tc008b008&desc=下载APP">\
                    <a href="javascript:;" >下载APP体验更多互动</a>\
                    <i class="corner-icon login-qrcode-icon"></i>\
                </div>\
            </div>\
        </div>',

    registerForm:
      '<div class="register-form-content popup-content-inner">\
            <div class="popup-content-title">\
                <h6>欢迎来到么么！</h6>\
                <p>每天超过50万人使用的真实视频交友平台</p>\
                <div class="ui-form-tip error-tip"></div>\
            </div>\
            <form id="app-register-form" autocomplete="off" style="position: relative;z-index: 10;">\
                <div class="login-form-sms"></div>\
                <div class="ui-form-item login-form-password"></div>\
                <div class="ui-form-item-submit"><p class="ui-form-btn btn-register" data-sawebclick="id=tc007b001&desc=注册">注&nbsp;&nbsp;册</p></div>\
                <div class="extra-form-content text-center" style="white-space: nowrap;">\
                    <span>注册么么直播表示您已同意<a href="https://www.2339.com/notice/10097" target="_blank" data-sawebclick="id=tc007b004&desc=么么直播服务协议">《么么直播服务协议》</a><a href="https://www.2339.com/notice/10468" target="_blank">《么么直播隐私政策》</a></span>\
                </div>\
            </form>\
            <div class="user-popup-bottom">\
                <div class="bottom-extra fl">\
                    <span data-tab="loginForm" data-sawebclick="id=tc007b002&desc=立即登录">立即登录</span>\
                </div>\
                <div class="bottom-conner fr" data-tab="download" data-sawebclick="id=tc007b005&desc=下载APP">\
                    <a href="javascript:;" >下载APP体验更多互动</a>\
                    <i class="corner-icon login-qrcode-icon"></i>\
                </div>\
            </div>\
        </div>',

    download:
      '<div class="download-content popup-content-inner">\
            <div class="popup-content-title text-center">\
                <div class="download-title" />\
                <p class="download-erwei-p">观看使用体验更顺滑，零距离接触更多颜值美女！</p>\
            </div>\
            <div class="app-qrcode">\
                <div class="app-qrcode-img"></div>\
            </div>\
            <ul>\
                <li class="dwn-android-btn inline" data-sawebclick="id=tc003b001&desc=安卓下载"><a href="http://dl.sumeme.com/app/memezhibo.apk" title="安卓下载" target="_blank"><i class="iconfont icon-anzhuo- inline"></i><span class="inline">下载Android版</span></a></li>\
                <li class="dwn-ios-btn inline" data-sawebclick="id=tc003b002&desc=iOS下载"><a href="https://apps.apple.com/cn/app/id1532193303" title="iOS下载" target="_blank"><i class="iconfont icon-pingguo1 inline"></i><span class="inline">下载iPhone版</span></a></li>\
            </ul>\
            <div class="user-popup-bottom" data-tab="thirdLogin">\
                <div class="bottom-conner fr">\
                    <a href="javascript:;" data-sawebclick="id=tc003b003&desc=返回登录">返回登录</a>\
                    <i class="corner-icon login-pc-icon"></i>\
                </div>\
            </div>\
        </div>',

    safeCheck:
      '<div class="safe-check-content popup-content-inner">\
            <div class="popup-content-title">\
                <h6>欢迎回来，朋友</h6>\
                <p>登录您的账号，让我们来一次重逢吧！</p>\
                <div class="ui-form-tip error-tip"></div>\
            </div>\
            <form id="app-login-form" autocomplete="off">\
                <div class="login-form-sms"></div>\
            </form>\
            <div class="user-popup-bottom">\
                <div class="bottom-conner fr" data-tab="download" data-sawebclick="id=tc008b008&desc=下载APP">\
                    <a href="javascript:;" >下载APP体验更多互动</a>\
                    <i class="corner-icon login-qrcode-icon"></i>\
                </div>\
            </div>\
        </div>',
  };

  var $userPopup;
  var _tabs = {
    thirdLogin: 'thirdLogin',
    loginForm: 'loginForm',
    registerForm: 'registerForm',
    download: 'download',
    safeCheck: 'safeCheck',
  };

  /**
   * 弹出登陆弹窗
   * @param {String|Object} typeObject
   *  当String时，为展示类型
   *  当Object时，必须包含type字段
   *  typeObject.force 是否强制登陆
   * @param {Function} callback
   */
  function show(typeObject, callback) {
    var popupClasses = 'user-login-popup';

    if ($.os.ria) {
      popupClasses += ' ria-login';
    }

    var type = _.isString(typeObject) ? typeObject : _.get(typeObject, 'type');
    var isForce = _.get(typeObject, 'force') || false;

    if (!type) return;

    // 已经存在弹框 不再重新渲染 直接切换 内容
    if ($('.' + popupClasses).length) {
      return renderContent(type, callback);
    }

    MM.ui.popup.show({
      newUi: true,
      classes: popupClasses,
      center: true,
      noTitle: true,
      content: _template.wrapper,
      disableMsk: isForce,
      appendCallback: function ($popup) {
        $userPopup = $popup.find('.user-popup-content');
        if (isForce) {
          $popup.find('.icon-close').hide();
        }
        renderContent(type, callback);
        bindEvents();
      },
    });
  }

  function bindEvents() {
    // 兼容360浏览 强制保存 输入信息
    $userPopup
      .parent()
      .find('.autocomplete-off input')
      .each(function () {
        //遍历不需要自动填充的元素
        //复制该元素(this.outerHTML)并添加到后面，然后隐藏该元素并置name属性为空
        //只能隐藏而不能使用remove方法去除该元素，否则失效
        $(this).after(this.outerHTML).attr('name', '').hide();
      });
    $userPopup.on('click', '[data-tab]', function () {
      var tab = $(this).data('tab');
      if (tab === _tabs.loginForm) {
        return MM.user.login.popupLogin(_tabs.loginForm);
      }

      if (tab === _tabs.registerForm) {
        return MM.user.register.popupRegister();
      }

      renderContent(tab);
    });
  }

  function renderContent(tab, callback) {
    var innerClass = '.' + _.kebabCase(tab) + '-content';
    var $inner = $userPopup.find(innerClass);

    $userPopup.find('.popup-content-inner:not(.hide)').addClass('hide');

    if (!$inner.length) {
      $userPopup.append(_template[_tabs[tab]]);
      $inner = $userPopup.find(innerClass);
      callback && callback($userPopup);
    } else {
      $inner.removeClass('hide');
    }

    switch (tab) {
      case _tabs.loginForm:
        return $userPopup.find('[name="username"]').focus();
      case _tabs.registerForm:
        return $userPopup.find('.mobile-input').focus();
    }
  }

  return {
    show: show,
  };
});
